import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.1664 11.6662V6.66619H10.8331V11.6662H9.1664Z",
			fill: "#996006"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.74973 14.5829C8.74973 15.2732 9.30938 15.8329 9.99973 15.8329C10.6901 15.8329 11.2497 15.2732 11.2497 14.5829C11.2497 13.8925 10.6901 13.3329 9.99973 13.3329C9.30938 13.3329 8.74973 13.8925 8.74973 14.5829Z",
			fill: "#996006"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.465263 16.7183L8.52748 1.52414C9.15394 0.343513 10.8455 0.343515 11.472 1.52415L19.5342 16.7183C20.1232 17.8284 19.3186 19.1662 18.062 19.1662H1.93751C0.680866 19.1662 -0.123747 17.8284 0.465263 16.7183ZM1.93751 17.4995L9.99973 2.30534L18.062 17.4995H1.93751Z",
			fill: "#996006"
		})
	]
});
const ForwardRef = forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
